import { render, staticRenderFns } from "./CodeTable.vue?vue&type=template&id=16773d0c&scoped=true&"
import script from "./CodeTable.vue?vue&type=script&lang=js&"
export * from "./CodeTable.vue?vue&type=script&lang=js&"
import style0 from "./CodeTable.vue?vue&type=style&index=0&id=16773d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16773d0c",
  null
  
)

export default component.exports